import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
// External
import PostSkeleton from 'components/PostSkeleton';
import Fetch from 'components/Fetch';
import API_NAME from 'services/api';
import {
  openSidebarComments,
  actionTypes,
} from 'store/sideBarControler/actions';
// Own
import Sensor from 'components/Sensor';
import ProfilePhotoPost from 'components/ProfilePhotoPost';
import ProfileLinkPost from 'components/ProfileLinkPost';
import ProfileVehiclePost from 'components/ProfileVehiclePost';
import ProfileCreateEventPost from 'components/ProfileCreateEventPost';
import ProfileMembershipPost from 'components/ProfileMembershipPost';
import ProfileAttendEventPost from 'components/ProfileAttendEventPost';
import RoutePhotoPost from 'components/RoutePhotoPost';
import { ScrollToLoad } from 'components';
import { useCallback, useEffect, useMemo, useState } from 'react';
import fetchApi from 'hooks/fetchApi';
import RewardPointsEarnedPost from 'components/RewardPointsEarnedPost';
import FeedDiscussionPost from 'components/FeedDiscussionPost';
import {
  Wrapper,
  HeaderWrapper,
  Header,
  PostWrapper,
  ShowPinnedPostContainer,
  ShowPinnedText,
} from './styles';
import { IPostsProfile } from './Types';

const DEFAULT_PAGE_SIZE = 20;

const ProfilePosts = ({ id }: IPostsProfile) => {
  // Redux state
  const followingData = useSelector((store) => store.fetchData);
  const [total, setTotal] = useState<any>(
    followingData[API_NAME.PROFILE_GET_POSTS]?.data?.length + 1 || 0
  );
  const { t } = useTranslation();
  const dispatch = useDispatch();
  // const data = postsData[API_NAME.PROFILE_GET_POSTS]?.data;
  const { action, loading } = fetchApi();
  const [showPinnedList, setShowPinnedList] = useState<boolean>(false);

  const onCommentsClick = (id: string, postType: string) => {
    dispatch(
      openSidebarComments({
        actionType: actionTypes.OPEN_SIDEBAR_COMMENTS,
        commentsPostId: id,
        commentsType: postType,
      })
    );
  };

  const fetchMore = useCallback(
    async (data = []) => {
      const res = await action(
        API_NAME.PROFILE_GET_POSTS,
        {
          params: {
            userId: id,
            start: data?.length,
            limit: DEFAULT_PAGE_SIZE,
            pin: showPinnedList,
          },
        },
        true,
        true,
        data
      );
      if (res?.data) {
        if (Array.isArray(res?.data)) {
          setTotal((preState) => preState + res?.data?.length + 1);
        }
      }
    },
    [id, showPinnedList]
  );

  useEffect(() => {
    fetchMore([]);
  }, [showPinnedList, fetchMore]);

  const fetchMoreData = async (d) => {
    await fetchMore(followingData[API_NAME.PROFILE_GET_POSTS]?.data);
  };

  const onHandlePinPost = async (postId, pin) => {
    try {
      const res = await action(API_NAME.PIN_USER_POST, {
        params: {
          postId: postId,
        },
        body: {
          pin: pin,
        },
      });
      if (res) {
        fetchMore([]);
      }
    } catch (error) {
      console.log('erorr', error);
    } finally {
      return;
    }
  };

  // useEffect(() => {
  //   const sortedItems = followingData[API_NAME.PROFILE_GET_POSTS]?.data?.sort(
  //     (a, b) => {
  //       if (a.pin && !b.pin) return -1;
  //       if (!a.pin && b.pin) return 1;
  //       return 0;
  //     }
  //   );
  //   console.log('sortedItems==>',sortedItems);

  // }, [followingData[API_NAME.PROFILE_GET_POSTS]?.data]);

  const getSortedPosts = useCallback(() => {
    const posts = followingData[API_NAME.PROFILE_GET_POSTS]?.data;

    return posts?.sort((a, b) => {
      if (a.pin && !b.pin) return -1;
      if (!a.pin && b.pin) return 1;
      return 0;
    });
  }, [followingData]);

  const sortedPosts = useMemo(() => getSortedPosts(), [getSortedPosts]);

  return (
    <Wrapper>
      <HeaderWrapper>
        <Header>{t('feed:posts')}</Header>

        {followingData[API_NAME.PROFILE_GET_POSTS]?.data &&
          followingData[API_NAME.PROFILE_GET_POSTS]?.data?.some(
            (item) => item?.pin
          ) && (
            <ShowPinnedPostContainer>
              <ShowPinnedText
                onClick={() => setShowPinnedList((prev) => !prev)}
              >
                {showPinnedList
                  ? t('common:showAllPosts')
                  : t('common:showPinnedPosts')}
              </ShowPinnedText>
            </ShowPinnedPostContainer>
          )}
      </HeaderWrapper>
      <PostWrapper>
        <ScrollToLoad
          pageSize={DEFAULT_PAGE_SIZE}
          loader={<PostSkeleton />}
          totalData={total}
          // data={followingData[API_NAME.PROFILE_GET_POSTS]?.data}
          data={sortedPosts}
          fetchMoreData={fetchMoreData}
          scrollableTarget="scrollTarget"
          render={(p, i) => {
            const type = p?.type;
            if (type === 1) {
              return (
                <Sensor key={p?._id} id={p?._id}>
                  <ProfilePhotoPost
                    id={p?._id}
                    profilePhoto={p?.creator?.data?.profilePhoto}
                    creatorId={p?.creator?.data?._id}
                    username={p?.creator?.data?.username}
                    userId={p?.creator?.data?._id}
                    fullname={p?.creator?.data?.fullName}
                    isVerified={p?.creator?.data?.isVerified}
                    isAmbassador={p?.creator?.data?.isAmbassador}
                    isDonor={p?.creator?.data?.isDonor}
                    isMe={p?.isMine}
                    followingStatus={p?.creator?.data?.followingStatus}
                    postTime={p?.datetime}
                    media={p?.media}
                    mediaObjects={p?.mediaObjects}
                    users={p?.users}
                    groups={p?.groups}
                    events={p?.events}
                    text={p?.text}
                    origin={p?.origin}
                    originId={p?.originId}
                    locationName={p?.location?.name}
                    commentsCount={p?.commentsCount}
                    sharesCount={p?.sharesCount}
                    isLike={p?.isLike}
                    likes={p?.likes}
                    collaborators={p?.collaborators}
                    data={p}
                    onCommentClick={(id) => onCommentsClick(id, p?.origin)}
                    onPinPress={() => onHandlePinPost(p?._id, !p?.pin)}
                  />
                </Sensor>
              );
            }
            if (type === 3) {
              return (
                <Sensor key={p?._id} id={p?._id}>
                  <ProfileLinkPost
                    id={p?._id}
                    profilePhoto={p?.creator?.data?.profilePhoto}
                    userId={p?.creator?.data?._id}
                    creatorId={p?.creator?.data?._id}
                    username={p?.creator?.data?.username}
                    fullname={p?.creator?.data?.fullName}
                    isVerified={p?.creator?.data?.isVerified}
                    isAmbassador={p?.creator?.data?.isAmbassador}
                    isDonor={p?.creator?.data?.isDonor}
                    isMe={p?.isMine}
                    followingStatus={p?.creator?.data?.followingStatus}
                    postTime={p?.datetime}
                    users={p?.users}
                    groups={p?.groups}
                    events={p?.events}
                    text={p?.text}
                    origin={p?.origin}
                    originId={p?.originId}
                    locationName={p?.location?.name}
                    commentsCount={p?.commentsCount}
                    sharesCount={p?.sharesCount}
                    isLike={p?.isLike}
                    likes={p?.likes}
                    link={p?.link}
                    linkImage={p?.linkImage}
                    linkTitle={p?.linkTitle}
                    linkHost={p?.linkHost}
                    collaborators={p?.collaborators}
                    data={p}
                    onCommentClick={(id) => onCommentsClick(id, p?.origin)}
                    isClickable
                    onPinPress={() => onHandlePinPost(p?._id, !p?.pin)}
                  />
                </Sensor>
              );
            }
            if (type === 4) {
              return (
                <Sensor key={p?._id} id={p?._id}>
                  <ProfileVehiclePost
                    key={p?._id}
                    id={p?._id}
                    profilePhoto={p?.creator?.data?.profilePhoto}
                    userId={p?.creator?.data?._id}
                    creatorId={p?.creator?.data?._id}
                    username={p?.creator?.data?.username}
                    fullname={p?.creator?.data?.fullName}
                    isVerified={p?.creator?.data?.isVerified}
                    isAmbassador={p?.creator?.data?.isAmbassador}
                    isDonor={p?.creator?.data?.isDonor}
                    isMe={p?.isMine}
                    followingStatus={p?.creator?.data?.followingStatus}
                    postTime={p?.datetime}
                    mediaObjects={p?.mediaObjects}
                    origin={p?.origin}
                    originId={p?.originId}
                    commentsCount={p?.commentsCount}
                    sharesCount={p?.sharesCount}
                    isLike={p?.isLike}
                    likes={p?.likes}
                    make={p?.vehicle?.make}
                    model={p?.vehicle?.model}
                    year={p?.vehicle?.year}
                    collaborators={p?.collaborators}
                    data={p}
                    onCommentClick={(id) => onCommentsClick(id, p?.origin)}
                  />
                </Sensor>
              );
            }
            if (type === 6) {
              return (
                <Sensor key={p?._id} id={p?._id}>
                  <ProfileCreateEventPost
                    key={p?._id}
                    id={p?._id}
                    profilePhoto={p?.creator?.data?.profilePhoto}
                    userId={p?.creator?.data?._id}
                    creatorId={p?.creator?.data?._id}
                    username={p?.creator?.data?.username}
                    fullname={p?.creator?.data?.fullName}
                    isVerified={p?.creator?.data?.isVerified}
                    isDonor={p?.creator?.data?.isDonor}
                    isAmbassador={p?.creator?.data?.isAmbassador}
                    isMe={p?.isMine}
                    postTime={p?.datetime}
                    followingStatus={p?.creator?.data?.followingStatus}
                    event={p?.event}
                    originId={p?.originId}
                    data={p}
                    collaborators={p?.collaborators}
                    isClickable
                  />
                </Sensor>
              );
            }
            if (type === 7) {
              return (
                <Sensor key={p?._id} id={p?._id}>
                  <ProfileMembershipPost
                    key={p?._id}
                    id={p?._id}
                    profilePhoto={p?.creator?.data?.profilePhoto}
                    userId={p?.creator?.data?._id}
                    creatorId={p?.creator?.data?._id}
                    username={p?.creator?.data?.username}
                    fullname={p?.creator?.data?.fullName}
                    isVerified={p?.creator?.data?.isVerified}
                    isAmbassador={p?.creator?.data?.isAmbassador}
                    isDonor={p?.creator?.data?.isDonor}
                    isMe={p?.isMine}
                    followingStatus={p?.creator?.data?.followingStatus}
                    postTime={p?.datetime}
                    group={p?.group}
                    origin={p?.origin}
                    originId={p?.originId}
                    collaborators={p?.collaborators}
                    privacy={p?.privacy}
                    isClickable
                  />
                </Sensor>
              );
            }

            if (type === 8 || type === 9) {
              return (
                <Sensor key={p?._id} id={p?._id}>
                  <RoutePhotoPost
                    key={p?._id}
                    id={p?._id}
                    profilePhoto={p?.creator?.data?.profilePhoto}
                    userId={p?.creator?.data?._id}
                    creatorId={p?.creator?.data?._id}
                    username={p?.creator?.data?.username}
                    fullname={p?.creator?.data?.fullName}
                    isVerified={p?.creator?.data?.isVerified}
                    isAmbassador={p?.creator?.data?.isAmbassador}
                    isDonor={p?.creator?.data?.isDonor}
                    isMe={p?.isMine}
                    followingStatus={p?.creator?.data?.followingStatus}
                    postTime={p?.datetime}
                    origin={p?.origin}
                    originId={p?.originId}
                    collaborators={p?.collaborators}
                    type={type}
                    postData={p}
                    onCommentClick={(id) => onCommentsClick(id, p?.origin)}
                  />
                </Sensor>
              );
            }

            if (type === 10) {
              return (
                <Sensor key={p?._id} id={p?._id}>
                  <RewardPointsEarnedPost
                    key={p?._id}
                    id={p?._id}
                    profilePhoto={p?.creator?.data?.profilePhoto}
                    userId={p?.creator?.data?._id}
                    creatorId={p?.creator?.data?._id}
                    username={p?.creator?.data?.username}
                    fullname={p?.creator?.data?.fullName}
                    isVerified={p?.creator?.data?.isVerified}
                    isAmbassador={p?.creator?.data?.isAmbassador}
                    isDonor={p?.creator?.data?.isDonor}
                    isMe={p?.isMine}
                    followingStatus={p?.creator?.data?.followingStatus}
                    postTime={p?.datetime}
                    origin={p?.origin}
                    originId={p?.originId}
                    collaborators={p?.collaborators}
                    type={type}
                    postData={p}
                    onCommentClick={(id) => onCommentsClick(id, p?.origin)}
                  />
                </Sensor>
              );
            }

            if (type === 11) {
              return (
                <Sensor key={p?._id} id={p?._id}>
                  <FeedDiscussionPost
                    id={p?._id}
                    title={p?.title}
                    profilePhoto={p?.creator?.data?.profilePhoto}
                    userId={p?.creator?.data?._id}
                    creatorId={p?.creator?.data?._id}
                    username={p?.creator?.data?.username}
                    fullname={p?.creator?.data?.fullName}
                    isVerified={p?.creator?.data?.isVerified}
                    isAmbassador={p?.creator?.data?.isAmbassador}
                    isDonor={p?.creator?.data?.isDonor}
                    geoLocation={p?.geoLocation}
                    isMe={p?.isMine}
                    followingStatus={p?.creator?.data?.followingStatus}
                    postTime={p?.datetime}
                    media={p?.media}
                    mediaObjects={p?.mediaObjects}
                    users={p?.users}
                    groups={p?.groups}
                    events={p?.events}
                    text={p?.text}
                    origin={p?.origin}
                    originId={p?.originId}
                    locationName={p?.location?.name}
                    commentsCount={p?.commentsCount}
                    sharesCount={p?.sharesCount}
                    isLike={p?.isLike}
                    likes={p?.likesCount}
                    collaborators={p?.collaborators}
                    data={p}
                    onCommentClick={(id) => onCommentsClick(id, p?.origin)}
                    onPinPress={() => onHandlePinPost(p?._id, !p?.pin)}
                  />
                </Sensor>
              );
            }

            if (type === 16) {
              return (
                <Sensor key={p?._id} id={p?._id}>
                  <ProfileAttendEventPost
                    key={p?._id}
                    id={p?._id}
                    profilePhoto={p?.creator?.data?.profilePhoto}
                    userId={p?.creator?.data?._id}
                    creatorId={p?.creator?.data?._id}
                    username={p?.creator?.data?.username}
                    fullname={p?.creator?.data?.fullName}
                    isVerified={p?.creator?.data?.isVerified}
                    isDonor={p?.creator?.data?.isDonor}
                    isAmbassador={p?.creator?.data?.isAmbassador}
                    isMe={p?.isMine}
                    postTime={p?.datetime}
                    followingStatus={p?.creator?.data?.followingStatus}
                    event={p?.event}
                    originId={p?.originId}
                    data={p}
                    collaborators={p?.collaborators}
                    isClickable
                  />
                </Sensor>
              );
            }
            return '';
          }}
        />
      </PostWrapper>
    </Wrapper>
  );
};
export default ProfilePosts;
